import { render, staticRenderFns } from "./search-box.vue?vue&type=template&id=5fcc3d1b&scoped=true&"
import script from "./search-box.vue?vue&type=script&lang=ts&"
export * from "./search-box.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcc3d1b",
  null
  
)

export default component.exports